export default __webpack_public_path__ + "static/media/ttc.94b1d86d.jpg";